import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js/object/define-property';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import React, { createContext, useContext, useState, useEffect } from 'react';
import { platform } from '../../utils/platform.js';
import { getDefaultHasStatusBar } from '../../utils/statusBar.js';
import { theme } from '../../utils/theme.js';

var _excluded = ["children"],
    _excluded2 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * undefined means we can't get initial values during SSR
 */
var TUXContext = /*#__PURE__*/createContext({
  platform: undefined,
  uniform: 'default',
  theme: undefined,
  dir: 'ltr',
  hasStatusBar: undefined,
  androidStatusBarHeight: 24,
  navBarHeight: undefined
});
TUXContext.displayName = 'TUXContext';
var useTUXContext = function useTUXContext() {
  return useContext(TUXContext);
};
/**
 * TUXProvider props are optional,
 * but when a prop exist, it's value can't be undefined
 */

var TUXProvider = function TUXProvider(props) {
  // do not directly modify parentContext to avoid side effect
  // e.g. if we modify prevContext.platform, this change will persist across different unit tests
  var parentContext = useTUXContext();

  var _useState = useState(parentContext),
      _useState2 = _slicedToArray(_useState, 2),
      currentContext = _useState2[0],
      setCurrentContext = _useState2[1];

  var children = props.children;
  useEffect(function () {
    // need to re-calculate currentContext because we'd like to react to parentContext change
    var updatedContext = _objectSpread({}, parentContext);

    if (updatedContext.theme === undefined) {
      updatedContext.theme = theme;
    }

    if (updatedContext.platform === undefined) {
      updatedContext.platform = platform;
    }

    if (updatedContext.hasStatusBar === undefined) {
      updatedContext.hasStatusBar = getDefaultHasStatusBar();
    }

    props.children;
        var propsContext = _objectWithoutProperties(props, _excluded);

    updatedContext = _objectSpread(_objectSpread({}, updatedContext), propsContext);
    setCurrentContext(updatedContext);
  }, [parentContext, props]); // when some context value depends on other context value
  // we should calculate them separately

  useEffect(function () {
    setCurrentContext(function (prevContext) {
      var updatedContext = _objectSpread({}, prevContext);

      if (updatedContext.navBarHeight === undefined) {
        updatedContext.navBarHeight = updatedContext.platform === 'iOS' ? 44 : 52;
      }

      props.children;
          var propsContext = _objectWithoutProperties(props, _excluded2);

      updatedContext = _objectSpread(_objectSpread({}, updatedContext), propsContext);
      return updatedContext;
    });
  }, [props]);
  return /*#__PURE__*/React.createElement(TUXContext.Provider, {
    value: currentContext
  }, /*#__PURE__*/React.createElement("div", {
    "data-theme": currentContext.theme,
    dir: currentContext.dir
  }, children));
};

export { TUXContext, TUXProvider, useTUXContext };
//# sourceMappingURL=TUXProvider.js.map
